import { styled } from '@mui/material';

export const ProgressionListBlankRow = styled('div')({
  marginTop: '20px',
});
